import { baseApiURL } from "../../Utilities/utility";

export function getNonStdMLFBData(
    siteToken,
    azureToken,
    userId,
    userEmail,
    roleName,
    gid,
    roleId,
    data
) {
    const options = {
        method: "post",
        headers: {
            Accept: "application/json, text/plain, */*",
            "Content-Type": "application/json",
            Authorization: "Bearer " + siteToken.token,
            AzureToken: azureToken,
            UserEmail: userEmail,
            RoleName: roleName,
            Gid: gid,
            Roleid: roleId,
            userId : userId

        },
        body : JSON.stringify(data),
    };
    return fetch(baseApiURL + "/NonStandardMLFB/SearchNonStandardMLFB",options)
        .then((response) => response.json())
        .then((data) => {
            return data.result;
        })
        .catch((error) => {
            console.log("Error : ", error);
        });
}

export function getCategory(siteToken,
    azureToken,
    userId,
    userEmail,
    gid,
    roleName,
    roleId) {
    const options = {
        method: "get",
        headers: {
            Authorization: "Bearer " + siteToken.token,
            AzureToken: azureToken,
            UserEmail: userEmail,
            RoleName: roleName,
            Gid: gid,
            Roleid: roleId,
            userId : userId
        },

    };
    return fetch(baseApiURL + "/NonStandardMLFB/getCategory", options)
        .then((response) => response.json())
        .then((data) => {
            return data.result;
        })
        .catch((error) => {
            console.log("Error : ", error);
        });
}
export function getSubCategory(siteToken,
    azureToken,
    userId,
    userEmail,
    gid,
    roleName,
    roleId,
    categoryId) {
    const options = {
        method: "get",
        headers: {
            Authorization: "Bearer " + siteToken.token,
            AzureToken: azureToken,
            UserEmail: userEmail,
            RoleName: roleName,
            Gid: gid,
            Roleid: roleId,
            userId : userId
        },

    };
    return fetch(baseApiURL + "/NonStandardMLFB/getSubCategory?categoryId=" + categoryId, options)
        .then((response) => response.json())
        .then((data) => {
            return data.result;
        })
        .catch((error) => {
            console.log("Error : ", error);
        });
}
export function getZCode(siteToken,
    azureToken,
    userId,
    userEmail,
    gid,
    roleName,
    roleId,
    subcatparentid
    ) {
    const options = {
        method: "get",
        headers: {
            Authorization: "Bearer " + siteToken.token,
            AzureToken: azureToken,
            UserEmail: userEmail,
            RoleName: roleName,
            Gid: gid,
            Roleid: roleId,
            userId : userId
        },

    };
    return fetch(baseApiURL + "/NonStandardMLFB/getZCodeTypeListIndex?subcatparentid=" +subcatparentid, options)
        .then((response) => response.json())
        .then((data) => {
            return data.result;
        })
        .catch((error) => {
            console.log("Error : ", error);
        });
}


export function GetDataToEditNonStandardMLFB(
    siteToken,
    azureToken,
    userId,
    userEmail,
    roleName,
    gid,
    roleId,
    data
) {
    const options = {
        method: "post",
        headers: {
            Accept: "application/json, text/plain, */*",
            "Content-Type": "application/json",
            Authorization: "Bearer " + siteToken.token,
            AzureToken: azureToken,
            UserEmail: userEmail,
            RoleName: roleName,
            Gid: gid,
            Roleid: roleId,
            userId : userId

        },
       // body : JSON.stringify(data),
    };
    return fetch(baseApiURL + "/NonStandardMLFB/GetDataToEditNonStandardMLFB?id=" + data,options)
        .then((response) => response.json())
        .then((data) => {
            return data.result;
        })
        .catch((error) => {
            console.log("Error : ", error);
        });
}

export function getDeviation(siteToken,
    azureToken,
    userId,
    userEmail,
    gid,
    roleName,
    roleId) {
    const options = {
        method: "get",
        headers: {
            Authorization: "Bearer " + siteToken.token,
            AzureToken: azureToken,
            UserEmail: userEmail,
            RoleName: roleName,
            Gid: gid,
            Roleid: roleId,
            userId : userId
        },

    };
    return fetch(baseApiURL + "/NonStandardMLFB/getDeviation", options)
        .then((response) => response.json())
        .then((data) => {
            return data.result;
        })
        .catch((error) => {
            console.log("Error : ", error);
        });
}
export function SearchGetNonStandardMLFB(
    siteToken,
    azureToken,
    userId,
    userEmail,
    roleName,
    gid,
    roleId,
    data
) {
    const options = {
        method: "post",
        headers: {
            Accept: "application/json, text/plain, */*",
            "Content-Type": "application/json",
            Authorization: "Bearer " + siteToken.token,
            AzureToken: azureToken,
            UserEmail: userEmail,
            RoleName: roleName,
            Gid: gid,
            Roleid: roleId,
            userId : userId

        },
        body : JSON.stringify(data),
    };
    return fetch(baseApiURL + "/NonStandardMLFB/SearchNonStandardMLFB",options)
        .then((response) => response.json())
        .then((data) => {
            return data.result;
        })
        .catch((error) => {
            console.log("Error : ", error);
        });
}
export function deleteNonStandarsMLFB(
    siteToken,
    azureToken,
    userId,
    userEmail,
    gid,
    roleName,
    roleId,
    categoryId
    
) {
    const options = {
        method: "post",
        headers: {
            Accept: "application/json, text/plain, */*",
            "Content-Type": "application/json",
            Authorization: "Bearer " + siteToken.token,
            UserEmail: userEmail,
            RoleName: roleName,
            Gid: gid,
            Roleid: roleId,
            AzureToken: azureToken,
            userId : userId
        },
        body: JSON.stringify(categoryId),
       
    };
    
    return fetch(baseApiURL + "/NonStandardMLFB/DeleteNonStandardMLFB?id=" + categoryId , options)
        .then((response) => response.json())
        .then((data) => {
            return data.result;
        })
        .catch((error) => {
            console.log("Error : ", error);
        });
}
export function createNonStandardMLFB(
    siteToken,
    azureToken,
    userId,
    userEmail,
    gid,
    roleName,
    roleId,
    data
) {
    const options = {
        method: "post",
        headers: {
            Accept: "application/json, text/plain, */*",
            "Content-Type": "application/json",
            Authorization: "Bearer " + siteToken.token,
            AzureToken: azureToken,
            UserEmail: userEmail,
            Gid: gid,
            RoleName: roleName,
            Roleid: roleId,
            userId : userId
            
        },
        body : JSON.stringify(data),
    };
    return fetch(baseApiURL + "/NonStandardMLFB/CreateNonStandardMLFB", options)
        .then((response) => response.json())
        .then((data) => {
            return data.result;
        })
        .catch((error) => {
            console.log("Error : ", error);
        });
}

export function editNonStandardMLFB(
    siteToken,
    azureToken,
    userId,
    userEmail,
    gid,
    roleName,
    roleId,
    data
) {
    const options = {
        method: "post",
        headers: {
            Accept: "application/json, text/plain, */*",
            "Content-Type": "application/json",
            Authorization: "Bearer " + siteToken.token,
            UserEmail: userEmail,
            RoleName: roleName,
            Gid: gid,
            Roleid: roleId,
            AzureToken: azureToken,
            userId : userId
            
            
        },
        body : JSON.stringify(data),
        
    };
    return fetch(baseApiURL + "/NonStandardMLFB/EditNonStandardMLFB", options)
        .then((response) => response.json())
        .then((data) => {
            return data.result;
        })
        .catch((error) => {
            console.log("Error : ", error);
        });
}